import React, { useEffect, useState } from "react";
import api from "../api/axios";
import homeapi  from "../api/homeapi";
import AdminLayout from "./AdminLayout";

/* ══════════════════════════════════════════
   ICONS
══════════════════════════════════════════ */
const EyeIcon    = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/></svg>;
const BanIcon    = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M3.5 3.5l9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const CheckIcon  = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const SearchIcon = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M10 10L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const CloseIcon  = () => <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const PhoneIcon  = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 2h3l1.5 3.5-2 1a9 9 0 004 4l1-2 3.5 1.5V13a1 1 0 01-1 1C5 14 2 8 2 3a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;
const MailIcon   = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.3"/><path d="M1 6l7 4 7-4" stroke="currentColor" strokeWidth="1.3"/></svg>;
const DocIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="2" y="1" width="10" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.3"/><path d="M5 5h5M5 8h5M5 11h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><path d="M10 1v3.5H14" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;
const ExternalIcon=()=><svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M6 2H2v12h12v-4M8 8l6-6M10 2h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const TruckIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="5" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 7h2l2 3v2h-4V7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="4" cy="13" r="1.5" fill="currentColor"/><circle cx="12" cy="13" r="1.5" fill="currentColor"/></svg>;
const TicketIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M5 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const MoneyIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 1v14M5 4h4.5a2 2 0 010 4H5m0 0h5a2 2 0 010 4H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const GroupIcon  = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.3"/><path d="M1 14c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.2"/><path d="M14 14c0-2-1.3-3.5-3-4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>;
//const KeyIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9.5l5 5M11.5 12l1.5 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const XCircleIcon= () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const WhatsAppIcon=()=><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;

/* ══════════════════════════════════════════
   SHARED COMPONENTS
══════════════════════════════════════════ */
const COLORS = ["#4ade80","#60a5fa","#fbbf24","#a78bfa","#f87171","#34d399"];

const Avatar = ({ name, size = 36, color }) => {
  const initials = name ? name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase() : "?";
  const bg = color || "linear-gradient(135deg,#1e3a2f,#16181f)";
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", background: typeof bg === "string" && bg.startsWith("linear") ? bg : `${bg}18`, border: "1px solid rgba(74,222,128,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.32, fontWeight: 700, color: color || "#4ade80", flexShrink: 0, letterSpacing: -0.5 }}>
      {initials}
    </div>
  );
};

const Badge = ({ children, variant = "neutral" }) => {
  const v = {
    warning: { background: "rgba(251,191,36,0.12)",  color: "#fbbf24", border: "rgba(251,191,36,0.2)"  },
    success: { background: "rgba(74,222,128,0.12)",  color: "#4ade80", border: "rgba(74,222,128,0.2)"  },
    danger:  { background: "rgba(248,113,113,0.12)", color: "#f87171", border: "rgba(248,113,113,0.2)" },
    info:    { background: "rgba(96,165,250,0.12)",  color: "#60a5fa", border: "rgba(96,165,250,0.2)"  },
    neutral: { background: "rgba(139,143,168,0.1)",  color: "#8b8fa8", border: "rgba(139,143,168,0.2)" },
  };
  const c = v[variant] || v.neutral;
  return <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, fontWeight: 600, background: c.background, color: c.color, border: `0.5px solid ${c.border}`, fontFamily: "'DM Mono', monospace" }}>{children}</span>;
};

const statusLabel = (status) => {
  const map = { pending:"En attente", approved:"Approuvé", rejected:"Rejeté", confirmed:"Confirmé", cancelled:"Annulé", PENDING:"En attente", APPROVED:"Approuvé", REJECTED:"Rejeté", ACTIVE:"Actif" };
  return map[status] ?? status;
};
const statusVariant = (status) => {
  const map = { confirmed:"success", approved:"success", APPROVED:"success", ACTIVE:"success", pending:"warning", PENDING:"warning", cancelled:"danger", rejected:"danger", REJECTED:"danger" };
  return map[status] ?? "neutral";
};

const SpinIcon = () => (
  <div style={{ width: 20, height: 20, border: "2px solid #2a2d38", borderTopColor: "#4ade80", borderRadius: "50%", animation: "spin 0.6s linear infinite" }} />
);

/* ══════════════════════════════════════════
   TRANSPORTER DETAIL PANEL
══════════════════════════════════════════ */
const DETAIL_TABS = ["Informations", "Documents", "Finances", "Transactions"];

const TransporterDetailPanel = ({ transporterId, onClose, onToggled }) => {
  const [data,       setData]       = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [tab,        setTab]        = useState("Informations");
  const [actionLoad, setActionLoad] = useState(null);
  const [docModal,   setDocModal]   = useState(null);

  useEffect(() => {
    if (!transporterId) return;
    setLoading(true);
    setTab("Informations");
    api.get(`/admin/transporter/${transporterId}/detail`)
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [transporterId]);

  const handleValidate = async () => {
    setActionLoad("validate");
    try {
      await api.post(`/admin/validate-transporter/${transporterId}`);
      onToggled && onToggled(transporterId, "validated");
      onClose();
    } catch {}
    setActionLoad(null);
  };

  const handleReject = async () => {
    setActionLoad("reject");
    try {
      await api.post(`/admin/reject-transporter/${transporterId}`);
      onToggled && onToggled(transporterId, "rejected");
      onClose();
    } catch {}
    setActionLoad(null);
  };

  const isPending = data?.status === "PENDING";
  const docBaseUrl = `${homeapi.defaults.baseURL}/uploads/transporters/`;

  const InfoRow = ({ label, value }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <span style={{ fontSize: 10, color: "#8b8fa8", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</span>
      <span style={{ fontSize: 13, color: "#c8cad8", fontWeight: 500 }}>{value ?? "—"}</span>
    </div>
  );

  const MiniStat = ({ icon, value, label, color }) => (
    <div style={{ background: "#0f1117", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px" }}>
      <div style={{ color, width: 26, height: 26, background: `${color}18`, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }}>{icon}</div>
      <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 15, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.3 }}>{value}</div>
      <div style={{ fontSize: 10.5, color: "#8b8fa8", marginTop: 2 }}>{label}</div>
    </div>
  );

  return (
    <>
      <div style={dp.backdrop} onClick={onClose} />
      <div style={dp.panel} className="detail-panel">

        {/* Header */}
        <div style={dp.header}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 0 }}>
            {data && <Avatar name={data.name} size={44} />}
            {loading
              ? <div style={{ height: 18, width: 150, background: "#2a2d38", borderRadius: 6 }} />
              : <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.4 }}>{data?.name}</div>
                  <div style={{ display: "flex", gap: 6, marginTop: 5, flexWrap: "wrap" }}>
                    <Badge variant={statusVariant(data?.status)}>{statusLabel(data?.status)}</Badge>
                    {data?.company && (
                      <span style={{ fontSize: 11, color: "#8b8fa8", background: "#1e2029", padding: "2px 8px", borderRadius: 6, display: "flex", alignItems: "center", gap: 4 }}>
                        <TruckIcon /> {data.company}
                      </span>
                    )}
                  </div>
                </div>
            }
          </div>
          <button style={dp.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>

        {/* Contact bar */}
        {!loading && data && (
          <div style={dp.contactBar}>
            <a href={`tel:${data.phone}`} style={dp.chip} className="dp-chip"><PhoneIcon /> {data.phone}</a>
            <a href={`mailto:${data.email}`} style={dp.chip} className="dp-chip">
              <MailIcon />
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>{data.email}</span>
            </a>
            {data.phone && (
              <a href={`https://wa.me/${data.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer"
                style={{ ...dp.chip, color: "#4ade80", borderColor: "rgba(74,222,128,0.2)" }} className="dp-chip">
                <WhatsAppIcon /> WhatsApp
              </a>
            )}
          </div>
        )}

        {/* Tabs */}
        <div style={dp.tabBar}>
          {DETAIL_TABS.map(t => (
            <button key={t} style={{ ...dp.tab, ...(tab === t ? dp.tabActive : {}) }} onClick={() => setTab(t)} className="dp-tab">
              {t}
              {t === "Documents" && (data?.documentsCount ?? 0) > 0 && <span style={dp.tabBadge}>{data.documentsCount}</span>}
              {t === "Transactions" && (data?.transactions?.length ?? 0) > 0 && <span style={dp.tabBadge}>{data.transactions.length}</span>}
            </button>
          ))}
        </div>

        {/* Body */}
        <div style={dp.body}>
          {loading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 200, gap: 12 }}>
              <SpinIcon />
              <span style={{ fontSize: 12, color: "#8b8fa8" }}>Chargement…</span>
            </div>
          ) : !data ? (
            <p style={{ color: "#f87171", textAlign: "center", padding: 40, fontSize: 13 }}>Impossible de charger les données.</p>
          ) : (
            <>
              {/* ── INFORMATIONS ── */}
              {tab === "Informations" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Identité & Contact</div>
                    <div style={dp.infoGrid}>
                      <InfoRow label="Nom complet"  value={data.name} />
                      <InfoRow label="Email"         value={data.email} />
                      <InfoRow label="Téléphone"     value={data.phone} />
                      <InfoRow label="Inscrit le"    value={data.createdAt ? new Date(data.createdAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "—"} />
                      <InfoRow label="Statut"        value={<Badge variant={statusVariant(data.status)}>{statusLabel(data.status)}</Badge>} />
                      <InfoRow label="Compte validé" value={data.isValidated ? <Badge variant="success">Oui</Badge> : <Badge variant="warning">Non</Badge>} />
                    </div>
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Société & Véhicule</div>
                    <div style={dp.infoGrid}>
                      <InfoRow label="Société"       value={data.company || data.company_name || data.companyName} />
                      <InfoRow label="Type véhicule" value={data.vehicleType} />
                      <InfoRow label="Capacité"      value={data.capacity ? `${data.capacity} places` : null} />
                      <InfoRow label="Coopérative"   value={data.cooperativeName} />
                    </div>
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Résumé activité</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                      <MiniStat icon={<TicketIcon />} value={data.totalBookings ?? 0}                              label="Réservations"  color="#fbbf24" />
                      <MiniStat icon={<MoneyIcon />}  value={Number(data.totalRevenue ?? 0).toLocaleString()}      label="MGA générés"   color="#4ade80" />
                      <MiniStat icon={<TruckIcon />}  value={data.totalTrips ?? 0}                                 label="Trajets"       color="#60a5fa" />
                      <MiniStat icon={<GroupIcon />}  value={data.transactions?.length ?? 0}                       label="Transactions"  color="#a78bfa" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── DOCUMENTS ── */}
              {tab === "Documents" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <p style={{ fontSize: 12, color: "#8b8fa8", margin: "0 0 4px" }}>Cliquez sur un document pour le visualiser.</p>
                  {[
                    { key: "cinDocument",          label: "Pièce d'identité (CIN / Passeport)", required: true  },
                    { key: "permisDocument",        label: "Permis de conduire",                  required: true  },
                    { key: "matriculationDocument", label: "Carte de matriculation",              required: true  },
                    { key: "cooperativeDocument",   label: "Attestation de coopérative",          required: false },
                  ].map(({ key, label, required }) => {
                    const filename = data[key];
                    const url = filename ? `${docBaseUrl}${filename}` : null;
                    return (
                      <div key={key} style={{ ...dp.docRow, opacity: url ? 1 : 0.5 }}>
                        <div style={{ width: 34, height: 34, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: url ? "rgba(74,222,128,0.1)" : "rgba(139,143,168,0.08)", color: url ? "#4ade80" : "#4a4d5e", flexShrink: 0 }}>
                          <DocIcon />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: url ? "#e8e9ed" : "#4a4d5e" }}>{label}</div>
                          <div style={{ fontSize: 11, color: "#8b8fa8", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {url ? filename : (required ? "Non fourni ⚠️" : "Non fourni (facultatif)")}
                          </div>
                        </div>
                        {url && (
                          <button style={dp.docBtn} onClick={() => setDocModal({ url, label })} className="dp-doc-btn">
                            <ExternalIcon /> Voir
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* ── FINANCES ── */}
              {tab === "Finances" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {[
                      { label: "Profit total généré",     value: `${Number(data.totalRevenue ?? 0).toLocaleString()} MGA`, color: "#4ade80" },
                      { label: "Transactions approuvées", value: (data.transactions || []).filter(t => t.status?.toLowerCase() === "approved").length, color: "#60a5fa" },
                      { label: "Montant versé",           value: `${Number((data.transactions || []).filter(t => t.status?.toLowerCase() === "approved").reduce((a, t) => a + Number(t.amount || 0), 0)).toLocaleString()} MGA`, color: "#a78bfa" },
                      { label: "En attente versement",    value: `${Number((data.transactions || []).filter(t => t.status?.toLowerCase() === "pending").reduce((a, t) => a + Number(t.amount || 0), 0)).toLocaleString()} MGA`, color: "#fbbf24" },
                    ].map(({ label, value, color }) => (
                      <div key={label} style={{ background: "#0f1117", border: `0.5px solid ${color}22`, borderRadius: 10, padding: "14px 16px" }}>
                        <div style={{ fontSize: 10, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 700, marginBottom: 8 }}>{label}</div>
                        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 16, fontWeight: 700, color, letterSpacing: -0.4 }}>{value}</div>
                      </div>
                    ))}
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Réservations</div>
                    {(data.bookings || []).length === 0
                      ? <p style={dp.empty}>Aucune réservation</p>
                      : <div style={{ overflowX: "auto" }}>
                          <table style={dp.table}>
                            <thead>
                              <tr>{["Client","Trajet","Montant","Statut","Date"].map(h => <th key={h} style={dp.th}>{h}</th>)}</tr>
                            </thead>
                            <tbody>
                              {(data.bookings || []).map((b, i) => (
                                <tr key={i} className="trow">
                                  <td style={dp.td}><span style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 12 }}>{b.client}</span></td>
                                  <td style={{ ...dp.td, color: "#8b8fa8", fontSize: 12 }}>{b.route}</td>
                                  <td style={dp.td}><span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#4ade80", fontWeight: 600 }}>{Number(b.amount).toLocaleString()}</span></td>
                                  <td style={dp.td}><Badge variant={statusVariant(b.status)}>{statusLabel(b.status)}</Badge></td>
                                  <td style={{ ...dp.td, color: "#8b8fa8", fontSize: 11 }}>{b.date ? new Date(b.date).toLocaleDateString("fr-FR") : "—"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                    }
                  </div>
                </div>
              )}

              {/* ── TRANSACTIONS ── */}
              {tab === "Transactions" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {(data.transactions || []).length === 0
                    ? <p style={dp.empty}>Aucune transaction</p>
                    : (data.transactions || []).map((t, i) => {
                        const st = (t.status || "pending").toLowerCase();
                        const color = st === "approved" ? "#4ade80" : st === "pending" ? "#fbbf24" : "#f87171";
                        return (
                          <div key={i} style={{ background: "#0f1117", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px", display: "flex", gap: 12, alignItems: "flex-start" }}>
                            <div style={{ width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: `${color}12`, color, flexShrink: 0 }}><MoneyIcon /></div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                <span style={{ fontSize: 14, fontWeight: 700, color: "#e8e9ed", fontFamily: "'DM Mono', monospace" }}>{Number(t.amount).toLocaleString()} MGA</span>
                                <Badge variant={statusVariant(t.status)}>{statusLabel(t.status)}</Badge>
                                {t.nomOperateur && <span style={{ fontSize: 10.5, background: "rgba(96,165,250,0.1)", color: "#60a5fa", padding: "2px 7px", borderRadius: 5, border: "0.5px solid rgba(96,165,250,0.2)", fontWeight: 600 }}>{t.nomOperateur}</span>}
                              </div>
                              <div style={{ fontSize: 11, color: "#8b8fa8", marginTop: 4, display: "flex", gap: 10, flexWrap: "wrap" }}>
                                {t.numeroOperateur && <span>📱 {t.numeroOperateur}</span>}
                                {t.motif && <span>— {t.motif}</span>}
                                {t.createdAt && <span>🗓 {new Date(t.createdAt).toLocaleDateString("fr-FR")}</span>}
                              </div>
                              {t.codePaiement && (
                                <div style={{ marginTop: 5, fontSize: 11, color: "#4ade80", fontFamily: "'DM Mono', monospace" }}>🔑 Code : {t.codePaiement}</div>
                              )}
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              )}
            </>
          )}
        </div>

        {/* Footer — actions validation */}
        {isPending && !loading && (
          <div style={dp.footer}>
            <div style={{ fontSize: 11, color: "#8b8fa8", marginBottom: 10 }}>Ce transporteur est en attente de validation.</div>
            <div style={{ display: "flex", gap: 10 }}>
              <button style={dp.rejectBtn} onClick={handleReject} disabled={!!actionLoad}>
                {actionLoad === "reject" ? "…" : <><XCircleIcon /> Rejeter</>}
              </button>
              <button style={dp.validateBtn} onClick={handleValidate} disabled={!!actionLoad}>
                {actionLoad === "validate" ? "…" : <><CheckIcon /> Valider le compte</>}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Document viewer */}
      {docModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} onClick={() => setDocModal(null)}>
          <div style={{ background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 14, padding: 20, width: "100%", maxWidth: 680, maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "#e8e9ed" }}>{docModal.label}</span>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={docModal.url} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, color: "#60a5fa", background: "rgba(96,165,250,0.1)", border: "0.5px solid rgba(96,165,250,0.2)", borderRadius: 6, padding: "5px 10px", textDecoration: "none" }}>
                  <ExternalIcon /> Ouvrir
                </a>
                <button style={dp.closeBtn} onClick={() => setDocModal(null)}><CloseIcon /></button>
              </div>
            </div>
            {docModal.url.match(/\.pdf$/i)
              ? <iframe src={docModal.url} style={{ width: "100%", height: 460, border: "none", borderRadius: 8 }} title={docModal.label} />
              : <img src={docModal.url} alt={docModal.label} style={{ width: "100%", maxHeight: 460, objectFit: "contain", borderRadius: 8 }} />
            }
          </div>
        </div>
      )}
    </>
  );
};

/* ══════════════════════════════════════════
   MAIN PAGE
══════════════════════════════════════════ */
const AdminTransporters = () => {
  const [data,         setData]         = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [search,       setSearch]       = useState("");
  const [filter,       setFilter]       = useState("all");
  const [togglingId,   setTogglingId]   = useState(null);
  const [toast,        setToast]        = useState(null);
  const [detailId,     setDetailId]     = useState(null);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { const r = await api.get("/admin/transporters"); setData(r.data);
     }
    catch (e) { console.error(e); }
    setLoading(false);
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleToggle = async (t) => {
    setTogglingId(t.id);
    try {
      await api.post(`/admin/transporters/${t.id}/toggle`);
      setData(d => d.map(x => x.id === t.id ? { ...x, active: !x.active } : x));
      showToast(t.active ? "Transporteur désactivé" : "Transporteur activé", t.active ? "danger" : "success");
    } catch { showToast("Erreur", "danger"); }
    setTogglingId(null);
  };

  // Called when detail panel validates/rejects
  const handleToggled = async (id, action) => {
    await load();
    if (action === "validated") showToast("Transporteur validé ✓", "success");
    if (action === "rejected")  showToast("Transporteur rejeté", "danger");
  };

  const filtered = data.filter(t => {
    const q = search.toLowerCase();
    const matchQ = !search || t.name?.toLowerCase().includes(q) || t.email?.toLowerCase().includes(q);
    const matchF = filter === "all" || (filter && filter.some && filter.some(x => x.id === t.id));
    return matchQ && matchF;
  });

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#0f1117", flexDirection: "column", gap: 12 }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <SpinIcon />
      <p style={{ color: "#8b8fa8", fontSize: 13 }}>Chargement des transporteurs…</p>
    </div>
  );

  return (
    <AdminLayout title="Transporteurs" subtitle="Gestion des comptes transporteurs">
      <style>{css}</style>

      {/* STATS MINI */}
      <div style={s.miniStats}>
        {[
          { label: "Total",      val: data.length,                     color: "#8b8fa8" },
          { label: "Actifs",     val: data.filter(t => t.status === "ACTIVE").length,  color: "#4ade80" },
          { label: "En attente", val: data.filter(t => t.status === "PENDING").length, color: "#fbbf24" },
        ].map(({ label, val, color }) => (
          <div key={label} style={s.miniStat}>
            <div style={{ fontSize: 20, fontWeight: 700, color, letterSpacing: -0.5 }}>{val}</div>
            <div style={{ fontSize: 11, color: "#8b8fa8" }}>{label}</div>
          </div>
        ))}
      </div>

      {/* TOOLBAR */}
      <div style={s.toolbar}>
        <div style={s.searchWrap}>
          <span style={s.searchIconWrap}><SearchIcon /></span>
          <input
            style={s.searchInput}
            placeholder="Rechercher un transporteur…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div style={s.filterTabs}>
          {[{v:"all",l:"Tous"},{v:data.filter(t => t.status === "ACTIVE"),l:"Actifs"},{v:data.filter(t => t.status === "PENDING"),l:"En attente"}].map(({v,l}) => (

            <button key={l} style={{ ...s.filterTab, ...(filter === v ? s.filterTabActive : {}) }} onClick={() => setFilter(v)}>{l}</button>
          ))}
        </div>
      </div>

      {/* TABLE */}
      <div style={s.card}>
        {filtered.length === 0 ? (
          <div style={s.empty}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🚌</div>
            <div style={{ fontSize: 14, color: "#8b8fa8" }}>Aucun transporteur trouvé</div>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={s.table}>
              <thead>
                <tr>{["Transporteur","Email","Société","Statut","Actions"].map(h => (
                  <th key={h} style={s.th}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {filtered.map((t, i) => (
                  <tr key={t.id} className="trow">
                    <td style={s.td}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <Avatar name={t.name} size={36} color={COLORS[i % COLORS.length]} />
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#e8e9ed" }}>{t.name}</div>
                          <div style={{ fontSize: 11, color: "#8b8fa8" }}>ID #{t.id}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ ...s.td, color: "#8b8fa8", fontSize: 13 }}>{t.email}</td>
                    <td style={s.td}>
                      <span style={{ fontSize: 12, color: "#c8cad8" }}>{t.company_name || t.companyName || "—"}</span>
                    </td>
                    <td style={s.td}>
                      <Badge variant={t.status === "ACTIVE" ? "success" : "warning"}>{t.status === "ACTIVE" ? "Actif" : "En attente"}</Badge>
                    </td>
                    <td style={s.td}>
                      <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                        {/* Voir détails — ouvre le panel complet */}
                        <button
                          style={{ ...s.actionBtn, color: "#60a5fa", borderColor: "rgba(96,165,250,0.2)", background: "rgba(96,165,250,0.08)" }}
                          onClick={() => setDetailId(t.id)}
                          title="Voir les détails"
                        >
                          <EyeIcon />
                        </button>
                        {/* Toggle actif/inactif */}
                        <button
                          style={{
                            ...s.actionBtn,
                            color:       t.active ? "#f87171" : "#4ade80",
                            borderColor: t.active ? "rgba(248,113,113,0.2)" : "rgba(74,222,128,0.2)",
                            background:  t.active ? "rgba(248,113,113,0.08)" : "rgba(74,222,128,0.08)",
                          }}
                          onClick={() => handleToggle(t)}
                          disabled={togglingId === t.id}
                          title={t.status === "ACTIVE" ? "Désactiver" : "Activer"}
                        >
                          {togglingId === t.id ? "…" : t.status === "ACTIVE" ? <BanIcon /> : <CheckIcon />}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* DETAIL PANEL */}
      {detailId && (
        <TransporterDetailPanel
          transporterId={detailId}
          onClose={() => setDetailId(null)}
          onToggled={handleToggled}
        />
      )}

      {/* TOAST */}
      {toast && (
        <div style={{ ...s.toast, borderColor: toast.type === "danger" ? "rgba(248,113,113,0.3)" : "rgba(74,222,128,0.3)" }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: toast.type === "danger" ? "#f87171" : "#4ade80", flexShrink: 0 }} />
          {toast.msg}
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminTransporters;

/* ══════════════════════════════════════════
   STYLES — PAGE
══════════════════════════════════════════ */
const s = {
  miniStats:      { display: "flex", gap: 14, marginBottom: 20 },
  miniStat:       { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "14px 20px", flex: 1, textAlign: "center" },
  toolbar:        { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, gap: 12, flexWrap: "wrap" },
  searchWrap:     { position: "relative", flex: 1, maxWidth: 340 },
  searchIconWrap: { position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#8b8fa8", pointerEvents: "none" },
  searchInput:    { width: "100%", padding: "9px 12px 9px 36px", background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 9, fontSize: 13, fontFamily: "'Plus Jakarta Sans',sans-serif", color: "#e8e9ed", outline: "none", boxSizing: "border-box" },
  filterTabs:     { display: "flex", gap: 4 },
  filterTab:      { fontSize: 12, padding: "7px 14px", borderRadius: 8, border: "0.5px solid #2a2d38", background: "none", cursor: "pointer", fontFamily: "'Plus Jakarta Sans',sans-serif", color: "#8b8fa8" },
  filterTabActive:{ background: "#1e2029", color: "#e8e9ed", borderColor: "#3a3d4a" },
  card:           { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 12, overflow: "hidden" },
  table:          { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th:             { padding: "10px 16px", color: "#8b8fa8", fontSize: 11, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "0.5px solid #2a2d38", textAlign: "left", background: "#13151b" },
  td:             { padding: "12px 16px", borderBottom: "0.5px solid #1e2029", verticalAlign: "middle" },
  actionBtn:      { width: 30, height: 30, borderRadius: 8, border: "0.5px solid #2a2d38", background: "#1e2029", color: "#8b8fa8", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13 },
  empty:          { textAlign: "center", padding: "48px 0" },
  toast:          { position: "fixed", bottom: 24, right: 24, background: "#16181f", border: "0.5px solid", padding: "11px 18px", borderRadius: 10, fontSize: 13, color: "#e8e9ed", zIndex: 999, display: "flex", alignItems: "center", gap: 8 },
};

/* ══════════════════════════════════════════
   STYLES — DETAIL PANEL
══════════════════════════════════════════ */
const dp = {
  backdrop:    { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", zIndex: 300 },
  panel:       { position: "fixed", top: 0, right: 0, bottom: 0, width: "min(540px,100vw)", background: "#16181f", borderLeft: "0.5px solid #2a2d38", zIndex: 301, display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "-20px 0 60px rgba(0,0,0,0.4)", fontFamily: "'Plus Jakarta Sans', sans-serif" },
  header:      { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, padding: "20px 24px 16px", borderBottom: "0.5px solid #2a2d38", flexShrink: 0 },
  closeBtn:    { background: "none", border: "none", cursor: "pointer", color: "#8b8fa8", padding: 6, display: "flex", borderRadius: 6, flexShrink: 0 },
  contactBar:  { display: "flex", gap: 8, padding: "12px 24px", borderBottom: "0.5px solid #1e2029", flexShrink: 0, flexWrap: "wrap" },
  chip:        { display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, color: "#8b8fa8", background: "#1e2029", border: "0.5px solid #2a2d38", borderRadius: 7, padding: "5px 10px", textDecoration: "none", maxWidth: "100%" },
  tabBar:      { display: "flex", borderBottom: "0.5px solid #2a2d38", flexShrink: 0, overflowX: "auto" },
  tab:         { padding: "11px 16px", fontSize: 12, fontWeight: 500, color: "#8b8fa8", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", borderBottom: "2px solid transparent", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 5 },
  tabActive:   { color: "#e8e9ed", borderBottomColor: "#4ade80" },
  tabBadge:    { fontSize: 10, background: "rgba(74,222,128,0.15)", color: "#4ade80", padding: "1px 5px", borderRadius: 4, fontWeight: 700 },
  body:        { flex: 1, overflowY: "auto", padding: "20px 24px" },
  footer:      { padding: "16px 24px", borderTop: "0.5px solid #2a2d38", background: "#13151b", flexShrink: 0 },
  validateBtn: { flex: 1, padding: "10px 18px", background: "rgba(74,222,128,0.12)", border: "0.5px solid rgba(74,222,128,0.3)", borderRadius: 9, fontSize: 13, fontWeight: 700, color: "#4ade80", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 },
  rejectBtn:   { padding: "10px 18px", background: "rgba(248,113,113,0.08)", border: "0.5px solid rgba(248,113,113,0.2)", borderRadius: 9, fontSize: 13, fontWeight: 600, color: "#f87171", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6 },
  section:     { background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "16px 18px" },
  sectionTitle:{ fontSize: 10.5, fontWeight: 700, color: "#4ade80", textTransform: "uppercase", letterSpacing: "0.7px", marginBottom: 14 },
  infoGrid:    { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px 20px" },
  docRow:      { display: "flex", alignItems: "center", gap: 12, background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px" },
  docBtn:      { display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: "#60a5fa", background: "rgba(96,165,250,0.08)", border: "0.5px solid rgba(96,165,250,0.2)", borderRadius: 6, padding: "5px 10px", cursor: "pointer", fontFamily: "inherit", flexShrink: 0 },
  empty:       { fontSize: 13, color: "#4a4d5e", textAlign: "center", padding: "32px 0" },
  table:       { width: "100%", borderCollapse: "collapse", fontSize: 12 },
  th:          { textAlign: "left", padding: "7px 10px", color: "#8b8fa8", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "0.5px solid #2a2d38", background: "#0f1117", whiteSpace: "nowrap" },
  td:          { padding: "10px 10px", borderBottom: "0.5px solid #1e2029", color: "#c8cad8", verticalAlign: "middle" },
};

/* ══════════════════════════════════════════
   GLOBAL CSS
══════════════════════════════════════════ */
const css = `
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }

  .trow:hover td { background: #1a1c25 !important; }
  input:focus    { border-color: #4ade80 !important; }

  .detail-panel  { animation: slideIn 0.22s cubic-bezier(0.22,1,0.36,1); }
  .dp-chip:hover { border-color: rgba(74,222,128,0.3) !important; color: #e8e9ed !important; }
  .dp-tab:hover  { color: #e8e9ed !important; }
  .dp-doc-btn:hover { background: rgba(96,165,250,0.15) !important; }

  .detail-panel ::-webkit-scrollbar       { width: 4px; }
  .detail-panel ::-webkit-scrollbar-track { background: transparent; }
  .detail-panel ::-webkit-scrollbar-thumb { background: #2a2d38; border-radius: 4px; }

  button:disabled { opacity: 0.4; cursor: not-allowed !important; }
`;